module.exports = __webpack_public_path__ + "img/nico-profile.f2c8612a.jpg";